import Vue from 'vue';
import App from './App.vue';
/* import VueViewload from 'vue-viewload'; */
import 'swiper/dist/js/swiper.min.js';
import './js/rem';
import 'swiper/dist/css/swiper.css';
import './css/animate.min.css';
import './css/reset.css';
import './css/index.css';
import './css/phone.css';
import $ from 'jquery';

// import vueResource from "vue-resource";
// Vue.use(vueResource);
// Vue.use(VueViewload);

new Vue({
  el: '#app',
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js